import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../../share/buttons/Btn";
import Inputs from "../../../share/input/Inputs";
import useFetch from "../../../../Hooks/useFetch";
import moment from "jalali-moment";
import { useCreate } from "../../../../Context/CreateContext";

const DiscountInfo = ({ close, getDiscounts, edit, setEdit }) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const [offType, setOffType] = useState("course-off");
    const [costType, setCostType] = useState("percentage");

    const [start, setStart] = useState();
    const [end, setEnd] = useState(null);
    const [call, setCall] = useState(null);
    const [startFinal, setStartFinal] = useState();
    const [endFinal, setEndFinal] = useState();
    const [tickets, setTickets] = useState();
    const [num, setNem] = useState(0);

    const [discount, setdiscount] = useState({
        bootcamp: null,
        ticket: null,
        user: 1,
        discount_name: "",
        discount_coupon_password: "",
        discount_amount: null,
        discount_percentage: null,
    });
    //TODO : id bootcamp bayad dynamic beshe

    const handleModalClose = () => {
        close(false);
        setdiscount({
            bootcamp: "",
            ticket: "",
            user: 1,
            discount_name: "",
            discount_coupon_password: "",
            discount_amount: "",
            discount_percentage: "",
        });
        setStart("");
        setEnd("");
        setEdit("");
    };

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    useEffect(() => {
        setStartFinal(moment(start, "HH:mm:ss jYYYY/jMM/jDD").format());
    }, [start]);
    useEffect(() => {
        setEndFinal(moment(end, "HH:mm:ss jYYYY/jMM/jDD").format());
    }, [end]);

    useEffect(() => {
        if (edit) {
            getDiscountId.reFetch();
        }
    }, [edit]);

    useEffect(() => {
        if (edit) {
            setStart(
                moment(discount.ticket_start_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );

            setEnd(
                moment(discount.ticket_end_time)
                    .locale("fa", { useGregorianParser: true })
                    .format("HH:mm:ss YYYY/MM/DD")
            );
        }
    }, [discount]);

    const submitForm = () => {
        if (edit) {
            editDiscount.reFetch();
            //TODO : pak kardane modal bad az patch
            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", bootCamp.id);
            offType === "ticket-off" &&
                formData.append("ticket", discount.ticket);
            formData.append("user", discount.user);
            formData.append("discount_name", discount.discount_name);
            formData.append("discount_coupon_password", discount.discount_name);
            //TODO : uuid random generator for coupon password

            costType === "amount" &&
                formData.append("discount_amount", discount.discount_amount);
            costType === "percentage" &&
                formData.append(
                    "discount_percentage",
                    discount.discount_percentage
                );

            formData.append("discount_start_time", startFinal);
            formData.append("discount_end_time", endFinal);

            setCall(formData);
            newDiscount.reFetch();

            setdiscount({
                bootcamp: "",
                ticket: "",
                user: 1,
                discount_name: "",
                discount_coupon_password: "",
                discount_amount: "",
                discount_percentage: "",
            });
            setStart("");
            setEnd("");
            setEdit("");

            close();
        }
    };

    const newDiscount = useFetch({
        method: "POST",
        url: `DiscountService`,
        noHeader: false,
        caller: getDiscounts,
        trigger: false,
        data: call,
    });

    const getDiscountId = useFetch({
        method: "GET",
        url: `DiscountService/${edit}`,
        noHeader: false,
        setter: setdiscount,
    });

    const editDiscount = useFetch({
        method: "PATCH",
        url: `DiscountService/${edit}`,
        noHeader: false,
        caller: getDiscounts,
        data: discount,
    });

    const getTickets = useFetch({
        method: "GET",
        url: `BootCampTicketService/${bootCamp.id}/tickets`,
        noHeader: false,
        trigger: true,
        setter: setTickets,
    });
    //TODO : hame ticketa ro bargaroone

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setdiscount({
            ...discount,
            ticket: value,
        });
    };

    return (
        <div className="relative">
            <button
                onClick={() => handleModalClose()}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold ">
                اطلاعات کدهای تخفیف
            </h3>
            <form
                onSubmit={handleSubmit(submitForm)}
                className="flex flex-col justify-center"
            >
                <div className="flex justify-around m-11">
                    <div className="flex items-center">
                        <input
                            register={{
                                required: {
                                    value: true,
                                },
                            }}
                            type="radio"
                            name="off-type"
                            id="1"
                            control={control}
                            className="PriceForm w-10 input"
                            isChecked={true}
                            value="course-off"
                            onChange={(e) => setOffType(e.target.value)}
                        />
                        <label className="text-[1.4rem] mr-3" htmlFor="1">
                            کد تخفیف برای کل دوره
                        </label>
                    </div>
                    <div className="flex items-center">
                        <input
                            register={{
                                required: {
                                    value: true,
                                },
                            }}
                            type="radio"
                            name="off-type"
                            id="2"
                            control={control}
                            value="ticket-off"
                            className="PriceForm w-10 input"
                            onChange={(e) => setOffType(e.target.value)}
                        />
                        <label className="text-[1.4rem] mr-3" htmlFor="2">
                            کد تخفیف برای هر بلیت
                        </label>
                    </div>
                </div>

                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    type="text"
                    value={discount.discount_name}
                    name="name"
                    full={true}
                    control={control}
                    placeholder="نام کد تخفیف*"
                    className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem] input"
                    onChange={(e) =>
                        setdiscount({
                            ...discount,
                            discount_name: e.target.value,
                        })
                    }
                />

                {offType === "ticket-off" && (
                    <select
                        register={{
                            required: {
                                value: true,
                                message: "Enter Name",
                            },
                        }}
                        type="text"
                        name="category"
                        onChange={handleInputChange}
                        value={discount.ticket}
                        control={control}
                        placeholder="بلیت مورد نظر"
                        className="border-gray input h-[6.4rem] w-full text-[#21212199] bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
                    >
                        <option value="" disabled selected>
                            بلیت مورد نظر*
                        </option>

                        {tickets?.results.map((ticket) => {
                            return (
                                <option key={ticket.id} value={ticket.id}>
                                    {ticket.ticket_name}
                                </option>
                            );
                        })}
                    </select>
                )}
                <div className="flex justify-around gap-8 mb-[1.6rem]">
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        setDate={setStart}
                        defaultValue={start}
                        message="زمان شروع تخفیف را وارد کنید"
                        placeholder="زمان شروع تخفیف *"
                        name="catch_end_date"
                        full={true}
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                    <DatePickerInput
                        register={{
                            required: true,
                        }}
                        setDate={setEnd}
                        defaultValue={end}
                        message="زمان پایان تخفیف را وارد کنید"
                        placeholder="زمان پایان تخفیف *"
                        name="catch_end_date"
                        full={true}
                        control={control}
                        plugins={[<TimePicker position="bottom" />]}
                    />
                </div>
                <div className="mb-12">
                    <p className="text-[1.8rem] mb-8">نوع تخفیف:</p>
                    <div className="flex items-center mb-8">
                        <input
                            type="radio"
                            name="cost-type"
                            id="cost1"
                            control={control}
                            className="PriceForm w-10 input"
                            isChecked={true}
                            value="percentage"
                            onChange={(e) => setCostType(e.target.value)}
                        />
                        <label
                            className="text-[1.4rem] mr-3 ml-20"
                            htmlFor="cost1"
                        >
                            درصدی
                        </label>
                        <input
                            register={{
                                required: {
                                    value: costType === "percentage" && true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            value={discount.discount_percentage}
                            name="name"
                            full={true}
                            disabled={costType === "percentage" ? false : true}
                            control={control}
                            placeholder="درصد کد تخفیف*"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] input disabled:bg-transparent disabled:placeholder-gray disabled:border-gray"
                            onChange={(e) =>
                                setdiscount({
                                    ...discount,
                                    discount_percentage: e.target.value,
                                })
                            }
                        />
                    </div>
                    <div className="flex items-center">
                        <input
                            type="radio"
                            name="cost-type"
                            id="cost2"
                            control={control}
                            className="PriceForm w-10 input"
                            value="amount"
                            onChange={(e) => setCostType(e.target.value)}
                        />
                        <label
                            className="text-[1.4rem] mr-3 ml-20"
                            htmlFor="cost2"
                        >
                            مبلغ ثابت
                        </label>
                        <input
                            register={{
                                required: {
                                    value: costType === "amount" && true,
                                    message: "Enter Name",
                                },
                            }}
                            type="text"
                            value={discount.discount_amount}
                            name="name"
                            full={true}
                            control={control}
                            placeholder="مبلغ کد تخفیف*"
                            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] input disabled:bg-transparent disabled:placeholder-gray disabled:border-gray"
                            disabled={costType === "percentage" ? true : false}
                            onChange={(e) =>
                                setdiscount({
                                    ...discount,
                                    discount_amount: e.target.value,
                                })
                            }
                        />
                    </div>
                </div>
                <div className="flex gap-48 self-end">
                    <BtnPrimary
                        className=" py-[20px] px-[81px] mr-auto"
                        text="ثبت تخفیف"
                        type="submit"
                    />
                </div>
            </form>
        </div>
    );
};

export default DiscountInfo;
